var n = 31,
    r = 12,
    a = {
  orange: 0,
  peach: 22,
  yellow: 60,
  green: 85,
  brightGreen: 145,
  lightBlue: 182,
  blue: 236,
  purple: 284,
  pink: 312
},
    t = function t(n, r) {
  var a = null;
  return Object.entries(n).forEach(function (n) {
    n[1] === r && (a = n[0]);
  }), a;
},
    e = function e(n, r, a) {
  var t,
      e = n / 255,
      c = r / 255,
      u = a / 255,
      o = Math.max(e, c, u),
      i = Math.min(e, c, u),
      s = o,
      f = o - i,
      l = 0 === o ? 0 : f / o;
  if (o === i) t = 0;else {
    switch (o) {
      case e:
        t = (c - u) / f + (c < u ? 6 : 0);
        break;

      case c:
        t = (u - e) / f + 2;
        break;

      case u:
        t = (e - c) / f + 4;
        break;

      default:
        t = 0;
    }

    t /= 6;
  }
  return [t, l, s];
},
    c = function c(n, r, a) {
  var t = n % 360 / parseFloat(360) * 6,
      e = 100 === r ? 1 : r % 100 / parseFloat(100),
      c = 100 === a ? 1 : a % 100 / parseFloat(100),
      u = Math.floor(t),
      o = t - u,
      i = c * (1 - e),
      s = c * (1 - o * e),
      f = c * (1 - (1 - o) * e),
      l = u % 6,
      b = [c, s, i, i, f, c][l],
      h = [f, c, c, s, i, i][l],
      g = [i, i, f, c, c, s][l];
  return {
    r: Math.round(255 * b),
    g: Math.round(255 * h),
    b: Math.round(255 * g)
  };
},
    u = function u(n) {
  return c(n, 50, 100);
},
    o = function o(n) {
  var r = u(n);
  return "rgb(".concat(r.r, ", ").concat(r.g, ", ").concat(r.b, ")");
},
    i = function i(n, r) {
  var a = ["r", "g", "b"].map(function (r) {
    var a = n[r],
        t = a.toString(16);
    return a < 16 && (t = "0".concat(t)), t;
  }).join("");
  return "".concat(!0 === r ? "#" : "0x").concat(a);
},
    s = function s(n, r) {
  var a = u(n);
  return i(a, r);
},
    f = function f(n) {
  if (null != n) {
    var r,
        e = Object.keys(a).map(function (n) {
      return a[n];
    }),
        c = (r = n, e.reduce(function (n, a) {
      return Math.abs(a - r) < Math.abs(n - r) ? a : n;
    }));
    return t(a, c);
  }
},
    l = function l(n) {
  var r = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(n);
  return r ? {
    r: parseInt(r[1], 16),
    g: parseInt(r[2], 16),
    b: parseInt(r[3], 16)
  } : null;
},
    b = function b(n, r) {
  return "rgba(".concat(n.r, ", ").concat(n.g, ", ").concat(n.b, ", ").concat(r, ")");
},
    h = function h(n, r) {
  var a = u(n);
  return b(a, r);
},
    g = function g(n, r) {
  var a = l(n);
  return b(a, r);
},
    p = function p(n) {
  return 12 * n;
},
    v = function v(n) {
  return Math.round(n / 360 * 30);
},
    d = function d(n) {
  return n % 360;
},
    M = function M(n, r) {
  return void 0 !== r ? s(r, !0) : n;
};

export { a as C, n as V, o as a, c as b, p as c, l as d, r as e, i as f, t as g, v as h, s as i, f as j, h as k, g as l, M as m, e as r, d as w };